/*
  THAANI UI-Buybox (snippets/thaani-ui-buybox.liquid).

  Schreibt Pack x Anzahl in Dawns Mengenfeld und den gewaehlten Plan ins
  Feld selling_plan, beides per form="" am Produktformular. Danach werden
  alle sichtbaren Preise aus denselben Zahlen gerechnet: Pack-Kacheln,
  Abo/Einmalkauf, grosser Preis, Portionszeile, Kaufbutton, Sticky-Leiste
  und Versandhinweis. So kann nirgends ein anderer Betrag stehen als der,
  der in den Warenkorb geht.

  Preis je Glas: Abo-Zuordnung (echter Plan) bzw. Vorschau-Rabatt, sonst
  Mengenpreis aus quantity_price_breaks, sonst Variantenpreis.

  Mix (data-mix): ab zwei Flaschen bzw. Glaesern waehlt man die Sorten des
  Pakets selbst. Die Kaufkarte bietet nur Sorten zum selben Preis an, darum
  gelten alle Preise oben unveraendert. Ein gemischtes Paket geht als eigene
  Positionen je Sorte in den Warenkorb.
*/

if (!customElements.get('thaani-ui-buybox')) {
  customElements.define(
    'thaani-ui-buybox',
    class ThaaniUiBuybox extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info') || this.closest('[data-ui-root]');
        this.base = Number(this.dataset.price) || 0;
        this.portions = Number(this.dataset.portions) || 0;
        this.mockPercent = Number(this.dataset.mockPercent) || 0;
        // Paket-Angebote als Vorschau ("3:15" = 3 Glaeser 15 % guenstiger,
        // "6:2" = 6 Glaeser plus 2 gratis). Nur Anzeige und Menge, der Preis
        // im Checkout kommt aus einem Shopify-Rabatt.
        const deals = (text) => Object.fromEntries(
          String(text || '').split(',').map((part) => part.split(':').map((n) => Number(n.trim()))).filter(([a, b]) => a > 0 && b > 0)
        );
        this.packRabatt = deals(this.dataset.packRabatt);
        this.packGratis = deals(this.dataset.packGratis);
        this.aboMode = this.dataset.aboMode || 'none';
        this.threshold = Number(this.dataset.threshold) || 0;
        this.cartTotal = Number(this.dataset.cartTotal) || 0;
        this.cartQuantity = Number(this.dataset.cartQuantity) || 0;
        this.breaks = this.readJson('[data-breaks]');
        this.plans = this.readJson('[data-plans]');
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'de-CH', {
          style: 'currency',
          currency: this.dataset.currency || 'CHF',
        });

        this.countInput = this.querySelector('[data-count]');
        this.planInput = this.querySelector('[data-selling-plan]');

        // Mix: zu Beginn liegt die Sorte dieser Seite auf dem ersten Platz.
        this.mix = this.querySelector('[data-mix]');
        if (this.mix) {
          this.mixKnoepfe = [...this.mix.querySelectorAll('[data-mix-sorte]')];
          const aktuell = this.mix.querySelector('[data-mix-aktuell]');
          this.mixAktuell = aktuell?.dataset.mixSorte || '';
          this.mixWahl = aktuell && !aktuell.disabled ? [this.mixAktuell] : [];
          this.mixStand = '';
        }

        // Die Abo-Karte ist kein Label mehr (snippets/thaani-ui-kaufkarte.liquid):
        // Ein Klick in die Karte oder ein Lieferintervall waehlt das Abo.
        this.waehleAbo = () => {
          const abo = this.querySelector('[data-kauf][value="abo"]');
          if (abo && !abo.checked) abo.checked = true;
        };

        this.onChange = (event) => {
          if (event.target === this.countInput) this.clampCount();
          if (event.target.matches('[data-interval]')) this.waehleAbo();
          // Funken bei 5 + 1 erst nach einem Wechsel, nicht beim Laden (assets/thaani-ui-produkt.css)
          if (event.target.matches('[data-pack]')) this.classList.add('is-gewechselt');
          this.sync();
        };
        this.onClick = (event) => {
          const sorte = event.target.closest('[data-mix-sorte]');
          if (sorte) {
            this.mixDazu(sorte);
            return;
          }
          const platz = event.target.closest('[data-mix-platz]');
          if (platz) {
            this.mixWeg(Number(platz.dataset.mixPlatz));
            return;
          }
          if (event.target.closest('[data-abo-karte]')) {
            this.waehleAbo();
            this.sync();
          }
          const step = event.target.closest('[data-step]');
          if (!step || !this.countInput) return;
          this.countInput.value = Number(this.countInput.value || 1) + Number(step.dataset.step);
          this.clampCount();
          this.sync();
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);

        // Gemischtes Paket: Positionen je Sorte statt Dawns «N x diese Sorte».
        // Faengt das Absenden vor product-form ab (Capture), auch aus der
        // Sticky-Leiste, die dasselbe Formular absendet.
        // Formular-ID per getAttribute: form.id waere das Feld name="id".
        this.onSubmit = (event) => {
          if (!this.mixAktiv || event.target.getAttribute('id') !== this.dataset.form) return;
          const frei = this.mixPlaetze - this.mixWahl.length;
          const posten = this.mixPosten();
          if (frei === 0 && posten.length === 1 && String(posten[0].id) === this.mixAktuell) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (frei > 0) {
            this.mix.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.mixInDenWarenkorb(posten, event.target);
        };
        this.addEventListener('submit', this.onSubmit, true);

        // Mit dem Mix wird die Karte oft hoeher als das Fenster. Klebte sie
        // oben fest, waeren Kaufbutton und Garantie nicht zu sehen; dann klebt
        // sie erst, wenn ihr unteres Ende im Bild ist.
        this.buyWrap = this.closest('.ui-pdp__buy');
        if (this.buyWrap && 'ResizeObserver' in window) {
          this.onResize = () => this.syncUeberhang();
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this);
          window.addEventListener('resize', this.onResize);
        }

        // Abo-Vorteile weiter unten: Button springt hierher und waehlt das Abo.
        this.onAboLink = (event) => {
          const link = event.target.closest('[data-ui-abo-link]');
          if (!link) return;
          event.preventDefault();
          const abo = this.querySelector('[data-kauf][value="abo"]');
          if (abo) {
            abo.checked = true;
            this.sync();
          }
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          (abo || this.querySelector('[data-pack]:checked'))?.focus({ preventScroll: true });
        };
        document.addEventListener('click', this.onAboLink);

        // Dawn rendert Preis und Button nach dem Hinzufuegen neu, danach nachziehen.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.variantChange, () => {
              requestAnimationFrame(() => this.sync());
              this.refreshCart();
            }),
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              const total = event?.cartData?.total_price;
              if (typeof total === 'number') this.cartTotal = total;
              requestAnimationFrame(() => this.sync());
              this.refreshCart();
            }),
          ];
        }

        // Sofort rechnen, rAF laeuft in Hintergrund-Tabs nicht. Der zweite Lauf
        // faengt Dawns eigenen Preis-Rerender nach dem Laden ab.
        this.sync();
        this.frame = requestAnimationFrame(() => this.sync());
        this.onLoad = () => this.sync();
        window.addEventListener('load', this.onLoad, { once: true });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        window.removeEventListener('load', this.onLoad);
        document.removeEventListener('click', this.onAboLink);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('submit', this.onSubmit, true);
        this.resizeObserver?.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe?.());
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || '[]') || [];
        } catch (error) {
          return [];
        }
      }

      // Nach Warenkorb- oder Variantenwechsel Gesamtbetrag und Menge dieser
      // Variante im Warenkorb neu holen. Sonst rechnen Mengenpreis und
      // Versandhinweis mit dem Stand vom Seitenaufruf.
      async refreshCart() {
        // Nur die juengste Antwort zaehlt, falls zwei Anfragen sich ueberholen.
        const request = (this.cartRequest = (this.cartRequest || 0) + 1);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok || request !== this.cartRequest) return;
          const cart = await response.json();
          if (request !== this.cartRequest) return;
          this.cartTotal = Number(cart.total_price) || 0;
          // Variante aus dem Produktformular (data-form); es liegt nicht immer
          // im Element. Ohne Varianten-ID bleibt die bisherige Menge stehen.
          const form = document.getElementById(this.dataset.form);
          const variantId = String(form?.querySelector('input[name="id"]')?.value || this.querySelector('input[name="id"]')?.value || '');
          if (variantId) {
            this.cartQuantity = (cart.items || [])
              .filter((item) => String(item.variant_id) === variantId)
              .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
          }
          this.sync();
        } catch (error) {
          // Ohne Netz bleibt der letzte bekannte Stand stehen.
        }
      }

      money(cents) {
        return this.formatter.format(Math.round(cents) / 100);
      }

      clampCount() {
        const input = this.countInput;
        const max = Number(input.max) || 99;
        const value = Math.round(Number(input.value) || 1);
        input.value = Math.min(Math.max(value, 1), max);
      }

      get pack() {
        return Number(this.querySelector('[data-pack]:checked')?.value) || 1;
      }

      gratis(size) {
        return this.packGratis[size] || 0;
      }

      // Preis je bezahltem Glas nach Paket-Rabatt
      deal(price, size) {
        const percent = this.packRabatt[size] || 0;
        return percent > 0 ? Math.round(price * (1 - percent / 100)) : price;
      }

      get count() {
        return Number(this.countInput?.value) || 1;
      }

      // Intervall als Pillen (Radios) oder als Select
      get planValue() {
        const radio = this.querySelector('[data-interval]:checked');
        if (radio) return radio.value;
        const select = this.querySelector('select[data-interval]');
        return select ? select.value : '';
      }

      get isAbo() {
        return this.querySelector('[data-kauf]:checked')?.value === 'abo';
      }

      // Preis je Glas ohne Abo, inkl. Mengenpreis fuer die Gesamtmenge im Warenkorb.
      unitOneTime(quantity) {
        const eligible = this.breaks
          .filter((item) => item.minimum_quantity <= this.cartQuantity + quantity)
          .sort((a, b) => b.minimum_quantity - a.minimum_quantity);
        return eligible.length ? eligible[0].price : this.base;
      }

      unitAbo() {
        if (this.aboMode === 'real') {
          const planId = this.planValue;
          const allocation = this.plans.find((item) => String(item.selling_plan.id) === String(planId));
          return allocation ? allocation.price : this.base;
        }
        if (this.aboMode === 'mock') return Math.round(this.base * (1 - this.mockPercent / 100));
        return this.base;
      }

      unit(quantity) {
        return this.isAbo ? this.unitAbo() : this.unitOneTime(quantity);
      }

      // Gesamt und effektiver Preis je Glas fuer eine Packgroesse
      offer(size, abo = this.isAbo) {
        const paid = size * this.count;
        const quantity = (size + this.gratis(size)) * this.count;
        const price = abo ? this.unitAbo() : this.unitOneTime(paid);
        const total = this.deal(price, size) * paid;
        return { paid, quantity, total, unit: total / quantity };
      }

      percent(price) {
        return this.base > 0 ? Math.round(((this.base - price) / this.base) * 100) : 0;
      }

      sync() {
        const { quantity, unit, total } = this.offer(this.pack);

        this.writeForm(quantity);
        this.syncPacks();
        this.syncKauf();
        if (this.mix) this.syncMixCta(this.syncMix(total));

        const summary = this.querySelector('[data-summary]');
        if (summary) summary.textContent = this.count > 1 || quantity > this.pack ? `${quantity} × ${this.money(unit)}` : '';

        this.syncOutside(unit, total);
        this.classList.toggle('is-abo', this.isAbo);
      }

      // Plaetze im Paket: bezahlte plus Gratis-Flaschen der gewaehlten Packgroesse
      get mixPlaetze() {
        return this.pack + this.gratis(this.pack);
      }

      get mixAktiv() {
        return Boolean(this.mix) && this.mixPlaetze > 1;
      }

      mixKnopf(id) {
        return this.mixKnoepfe.find((knopf) => knopf.dataset.mixSorte === id);
      }

      mixDazu(knopf) {
        if (knopf.disabled || this.mixWahl.length >= this.mixPlaetze) return;
        this.mixWahl.push(knopf.dataset.mixSorte);
        this.sync();
      }

      mixWeg(index) {
        const [id] = this.mixWahl.splice(index, 1);
        this.sync();
        // Der Platz ist neu gezeichnet; der Fokus geht zur Sorte im Streifen.
        this.mixKnopf(id)?.focus({ preventScroll: true });
      }

      // Je Sorte eine Position, Menge mal Anzahl der Pakete
      mixPosten() {
        const mengen = new Map();
        this.mixWahl.forEach((id) => mengen.set(id, (mengen.get(id) || 0) + this.count));
        return [...mengen].map(([id, quantity]) => ({ id: Number(id), quantity }));
      }

      // Zeichnet Plaetze, Anzahl je Sorte, Zaehler und Summe des Mix. Gibt
      // zurueck, wie viele Plaetze noch frei sind (0, wenn kein Mix sichtbar).
      syncMix(total) {
        const plaetze = this.mixPlaetze;
        this.mix.hidden = plaetze <= 1;
        if (plaetze <= 1) {
          // Beim naechsten Einblenden neu zeichnen, damit die Plaetze wieder aufspringen
          this.mixStand = '';
          this.mixZahl = 0;
          return 0;
        }

        // Kleinere Packgroesse: die zuletzt gewaehlten Sorten fallen weg.
        if (this.mixWahl.length > plaetze) this.mixWahl.length = plaetze;
        const wahl = this.mixWahl;
        const frei = plaetze - wahl.length;
        const gratis = Math.min(this.gratis(this.pack), plaetze);
        const texte = this.mix.dataset;

        // Plaetze nur bei neuer Wahl neu zeichnen, sonst ginge der Fokus verloren.
        const stand = `${plaetze}:${gratis}:${wahl.join(',')}`;
        if (stand !== this.mixStand) {
          // Andere Packgroesse nach einem Wechsel: die Plaetze springen
          // nacheinander auf (Canvas «Kaufkarte: Packgroessen wechseln», Nr. 10).
          // Beim Laden und beim Antippen einer Sorte bleiben sie ruhig.
          const auftritt = this.classList.contains('is-gewechselt') && plaetze !== this.mixZahl;
          this.mixStand = stand;
          this.mixZahl = plaetze;
          const reihe = Array.from({ length: plaetze }, (_, index) =>
            this.mixPlatz(this.mixKnopf(wahl[index]), index, index >= plaetze - gratis)
          );
          reihe.forEach((platz, index) => platz.style.setProperty('--i', index));
          const behaelter = this.mix.querySelector('[data-mix-plaetze]');
          behaelter.classList.toggle('is-auftritt', auftritt);
          behaelter.replaceChildren(...reihe);
          // Mehr als vier Plaetze (5 + 1): alle in einer Reihe, etwas kleiner
          behaelter.classList.toggle('ui-mix__plaetze--reihe', plaetze > 4);
          behaelter.style.setProperty('--plaetze', plaetze);
        }

        this.mix.querySelector('[data-mix-zaehler]').textContent = texte.zaehler
          .replace('[anzahl]', wahl.length)
          .replace('[gesamt]', plaetze);
        const geschenkt = this.mix.querySelector('[data-mix-geschenkt]');
        if (geschenkt) {
          geschenkt.textContent = gratis > 0 ? (gratis === 1 ? texte.geschenktEins : texte.geschenktMehr).replace('[anzahl]', gratis) : '';
        }

        // Volles Paket: Streifen per aria-disabled sperren, damit der Fokus
        // auf der eben gewaehlten Sorte bleibt.
        this.mixKnoepfe.forEach((knopf) => {
          const anzahl = wahl.filter((id) => id === knopf.dataset.mixSorte).length;
          const badge = knopf.querySelector('[data-mix-anzahl]');
          if (badge) {
            badge.hidden = anzahl === 0;
            badge.textContent = anzahl;
          }
          knopf.classList.toggle('is-drin', anzahl > 0);
          if (frei === 0) knopf.setAttribute('aria-disabled', 'true');
          else knopf.removeAttribute('aria-disabled');
        });

        // Summe erst bei vollem Paket: Sorten, Portionen, Preis je Portion
        const summe = this.mix.querySelector('[data-mix-summe]');
        if (summe) {
          let text = '';
          if (frei === 0) {
            const mengen = new Map();
            wahl.forEach((id) => mengen.set(id, (mengen.get(id) || 0) + 1));
            const namen = [...mengen].map(([id, anzahl]) => {
              const name = this.mixKnopf(id)?.dataset.name || '';
              return anzahl > 1 ? `${anzahl} × ${name}` : name;
            });
            const portionen = wahl.map((id) => Number(this.mixKnopf(id)?.dataset.portionen) || 0);
            const alle = portionen.reduce((sum, wert) => sum + wert, 0) * this.count;
            text = namen.join(', ');
            if (alle > 0 && portionen.every((wert) => wert > 0)) {
              text += ` · ${texte.portionen.replace('[anzahl]', alle)} · ${this.money(total / alle)} ${this.dataset.portionLabel || ''}`.trimEnd();
            }
          }
          summe.textContent = text;
        }
        return frei;
      }

      // Ein Platz im Paket: voll ein Knopf mit dem Etikett der Sorte (ein
      // Klick nimmt sie heraus), frei ein gestrichelter Rahmen mit Plus.
      mixPlatz(knopf, index, istGratis) {
        const platz = document.createElement(knopf ? 'button' : 'span');
        platz.className = `ui-mix__platz ${knopf ? 'is-voll' : 'is-leer'}${istGratis ? ' is-gratis' : ''}`;
        const teil = (klasse, text) => {
          const span = document.createElement('span');
          span.className = klasse;
          span.textContent = text;
          return span;
        };
        if (knopf) {
          platz.type = 'button';
          platz.dataset.mixPlatz = index;
          platz.setAttribute('aria-label', this.mix.dataset.weg.replace('[name]', knopf.dataset.name));
          platz.style.setProperty('--c', knopf.style.getPropertyValue('--c'));
          if (knopf.classList.contains('is-hell')) platz.classList.add('is-hell');
          const weg = teil('ui-mix__weg', '×');
          weg.setAttribute('aria-hidden', 'true');
          platz.append(knopf.querySelector('.ui-mix__etikett').cloneNode(true), weg);
        } else {
          platz.setAttribute('aria-hidden', 'true');
          platz.append(teil('ui-mix__plus', '+'));
        }
        if (istGratis) platz.append(teil('ui-mix__gratis', this.mix.dataset.gratis));
        return platz;
      }

      // Solange Plaetze frei sind, sperrt der Kaufbutton und sagt, wie viele
      // Flaschen fehlen. Vor dem Verkaufsstart ist er ohnehin gesperrt und
      // bleibt unberuehrt.
      syncMixCta(frei) {
        const knopf = this.querySelector('.ui-kk__cta');
        const text = knopf?.querySelector(':scope > span');
        if (!text || (knopf.disabled && !this.mixCtaGesperrt)) return;
        if (frei > 0) {
          if (!this.mixCtaGesperrt) this.mixCtaHtml = text.innerHTML;
          this.mixCtaGesperrt = true;
          knopf.disabled = true;
          const texte = this.mix.dataset;
          text.textContent = (frei === 1 ? texte.nochEins : texte.nochMehr).replace('[anzahl]', frei);
        } else if (this.mixCtaGesperrt) {
          this.mixCtaGesperrt = false;
          knopf.disabled = false;
          text.innerHTML = this.mixCtaHtml;
        }
      }

      // Wie Dawns product-form (assets/product-form.js), nur mit mehreren
      // Positionen: Warenkorb-Schublade neu zeichnen und oeffnen.
      async mixInDenWarenkorb(posten, form) {
        const productForm = form.closest('product-form');
        const knopf = form.querySelector('[type="submit"]');
        const spinner = form.querySelector('.loading__spinner');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (knopf?.getAttribute('aria-disabled') === 'true') return;
        knopf?.setAttribute('aria-disabled', 'true');
        knopf?.classList.add('loading');
        spinner?.classList.remove('hidden');
        productForm?.handleErrorMessage?.();

        const plan = this.planInput?.value;
        const body = { items: posten.map((item) => (plan ? { ...item, selling_plan: plan } : item)) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }

        try {
          const response = await fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
          const data = await response.json();
          if (data.status) {
            productForm?.handleErrorMessage?.(data.description || data.message);
            return;
          }
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: posten[0].id, cartData: data });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch (error) {
          console.error(error);
          productForm?.handleErrorMessage?.(window.cartStrings?.error);
        } finally {
          knopf?.classList.remove('loading');
          knopf?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }

      // Ueberhang der Karte ueber das Fenster (Abstand oben plus 1.6rem unten);
      // die CSS-Regel zieht ihn vom Klebe-Abstand oben ab.
      syncUeberhang() {
        const wrap = this.buyWrap;
        wrap.style.removeProperty('--ui-kk-ueberhang');
        const stil = getComputedStyle(wrap);
        if (stil.position !== 'sticky') return;
        const top = parseFloat(stil.top) || 0;
        const ueberhang = Math.ceil(wrap.offsetHeight + top + 16 - window.innerHeight);
        if (ueberhang > 0) wrap.style.setProperty('--ui-kk-ueberhang', `${ueberhang}px`);
      }

      writeForm(quantity) {
        const input = this.productInfo?.querySelector('.quantity__input');
        if (input && String(input.value) !== String(quantity)) {
          input.value = quantity;
        }
        if (this.planInput) this.planInput.value = this.isAbo ? this.planValue || '' : '';
      }

      syncPacks() {
        this.querySelectorAll('[data-pack]').forEach((input) => {
          const size = Number(input.value);
          const card = input.nextElementSibling;
          const { unit, total } = this.offer(size);
          card.querySelector('[data-pack-total]').textContent = this.money(total / this.count);
          const portion = card.querySelector('[data-pack-portion]');
          if (portion && this.portions > 0) {
            portion.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
          }
          // Badge: Ersparnis je Glas aus Paket-Rabatt, Gratis-Glaesern und
          // Mengenpreisen. Das Abo hat sein eigenes Badge.
          const free = this.gratis(size);
          const oneTimePercent = this.percent(this.offer(size, false).unit);
          const freeText = free > 0 ? (this.dataset.gratisLabel || '+ [anzahl] gratis').replace('[anzahl]', free) : '';
          const extra = card.querySelector('[data-pack-gratis]');
          if (extra) {
            extra.hidden = free <= 0;
            extra.textContent = freeText;
          }
          const saving = card.querySelector('[data-pack-saving]');
          const popular = card.querySelector('[data-pack-popular]');
          if (saving) {
            saving.hidden = oneTimePercent <= 0;
            saving.textContent = oneTimePercent > 0 ? `${this.dataset.savingLabel} ${oneTimePercent} %` : '';
          }
          if (popular) popular.hidden = oneTimePercent > 0;
        });
      }

      syncKauf() {
        if (this.aboMode === 'none') return;
        const aboOffer = this.offer(this.pack, true);
        const oneOffer = this.offer(this.pack, false);
        const percent = this.percent(this.unitAbo());

        const aboPrice = this.querySelector('[data-abo-price]');
        const aboCompare = this.querySelector('[data-abo-compare]');
        const einmalPrice = this.querySelector('[data-einmal-price]');
        const badge = this.querySelector('[data-abo-badge]');

        if (aboPrice) aboPrice.textContent = this.money(aboOffer.total);
        if (aboCompare) {
          aboCompare.hidden = aboOffer.total >= oneOffer.total;
          // Durchgestrichen sieht man, hoeren nicht: davor ein verstecktes «statt»
          const statt = document.createElement('span');
          statt.className = 'visually-hidden';
          statt.textContent = `${this.dataset.compareLabel || ''} `;
          aboCompare.replaceChildren(statt, this.money(oneOffer.total));
        }
        if (einmalPrice) einmalPrice.textContent = this.money(oneOffer.total);
        if (badge) {
          badge.hidden = percent <= 0;
          badge.textContent = percent > 0 ? `${this.dataset.savingLabel} ${percent} %` : '';
        }
        const wrap = this.querySelector('[data-interval-wrap]');
        if (wrap) wrap.hidden = !this.isAbo;
      }

      syncOutside(unit, total) {
        const section = this.dataset.section;
        const root = this.productInfo || document;

        const price = document.getElementById(`price-${section}`);
        const regular = price?.querySelector('.price__regular .price-item--regular');
        if (regular) regular.textContent = this.money(unit);
        document.querySelectorAll(`[data-ui-unit="${section}"]`).forEach((node) => {
          node.textContent = this.money(unit);
        });
        document.querySelectorAll(`[data-ui-portion="${section}"]`).forEach((node) => {
          if (this.portions > 0) node.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
        });
        document.querySelectorAll(`[data-ui-total="${section}"]`).forEach((node) => {
          node.textContent = this.money(total);
        });

        const portion = root.querySelector('.thaani-portionen__preis');
        if (portion && this.portions > 0) {
          portion.textContent = `${this.money(unit / this.portions)} ${this.dataset.portionLabel || ''}`.trim();
        }

        const separator = this.dataset.ctaSeparator || ' – ';
        document.querySelectorAll(`[data-ui-cta-price="${section}"]`).forEach((node) => {
          node.textContent = `${separator}${this.money(total)}`;
        });

        document.querySelectorAll(`[data-ui-sticky-price="${section}"]`).forEach((node) => {
          node.textContent = this.money(total);
        });

        document.querySelectorAll(`[data-ui-versand="${section}"]`).forEach((node) => {
          if (!this.threshold) return;
          const missing = this.threshold - this.cartTotal - total;
          const reached = missing <= 0;
          node.classList.toggle('is-reached', reached);
          const text = node.querySelector('[data-versand-text]');
          if (text) {
            text.textContent = reached
              ? node.dataset.reached
              : node.dataset.missing.replace('[betrag]', this.money(missing));
          }
        });
      }
    }
  );
}
